// @flow
import { connect } from "react-redux"
import type { HOC } from "recompose"
import type { StoreState } from "global/store/reducers"

function withConnect<MapperAdd, DispatchAdd, Outter>(
  mapper: (state: StoreState) => MapperAdd,
  dispatch: DispatchAdd,
): HOC<{ ...$Exact<MapperAdd>, ...$Exact<DispatchAdd>, ...$Exact<Outter> }, Outter> {
  return connect(mapper, dispatch || {})
}

export default withConnect



// WEBPACK FOOTER //
// ./src/hoc/withConnect.js